import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { ManageScenarioWorkflowDataGridService } from 'libs/features/src/lib/layout/my-organization/manage-scenario-workflow/manage-scenario-workflow-data-grid.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-new-manage-scenario-workflow',
  templateUrl: './new-manage-scenario-workflow.component.html',
  styleUrls: ['./new-manage-scenario-workflow.component.scss'],
})
export class NewManageScenarioWorkflowComponent {
  @Output() saveManageScenarioWorkFlowEvent = new EventEmitter<any>();
  modalLabel: any;
  submitted = false;

  isPublicValue = true;
  manageScenarioWorkflowAddEditForm!: FormGroup;
  manageScenarioWorkFlowData: any;
  positionval: any;
  isShowError: boolean = false;

  showEdit: boolean = false;
  showCreate: boolean = false;
  showView: boolean = false;
  checkEntireAccess: boolean = false;
  isEdit: any;

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private cookieService: CookieService,
    private manageScenarioWorkflowDataGridService: ManageScenarioWorkflowDataGridService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.manageScenarioWorkFlowData =
      this.modal?.modalService?.config?.initialState?.['manageScenarioWorkflowData'];
    this.isEdit = this.modal?.modalService?.config?.initialState?.['isEdit'];
    this.isPublicValue =
      this.modalLabel == 'Review scenario status detail'
        ? this.manageScenarioWorkFlowData.isPublic
        : true;
  }

  ngOnInit(): void {
    this.showEdit = this.manageScenarioWorkflowDataGridService.isAccess('edit');
    this.showCreate = this.manageScenarioWorkflowDataGridService.isAccess('create');
    this.showView = this.manageScenarioWorkflowDataGridService.isAccess('view');
    this.checkEntireAccess =
      (this.showCreate && !this.isEdit) ||
      (this.isEdit && this.showEdit) ||
      (this.isEdit && !this.showView);
    this.manageScenarioWorkflowAddEditForm = this.formBuilder.group({
      label: [
        this.manageScenarioWorkFlowData.label || '',
        [Validators.required, noWhitespaceValidator],
      ],
      position: ['', [Validators.required, Validators.min(1), noWhitespaceValidator]],
    });
    this.setFormData();
  }

  setFormData() {
    this.manageScenarioWorkflowAddEditForm.patchValue({
      position: this.manageScenarioWorkFlowData.position,
    });
  }

  onClose() {
    this.modal.close();
  }

  isPublic(event: any) {
    this.isPublicValue = event.target.checked;
  }

  onSave() {
    this.submitted = true;
    this.positionval = this.manageScenarioWorkflowAddEditForm.value.position;
    const data = this.positionval.toString().includes('.');
    data ? (this.isShowError = true) : (this.isShowError = false);
    if (this.manageScenarioWorkflowAddEditForm.valid) {
      const manageScenarioWorkFlowAddEditPayload = {
        scenarioStatusId: this.manageScenarioWorkFlowData.scenarioStatusId || 0,
        label: this.manageScenarioWorkflowAddEditForm.controls['label'].value.trimStart(),
        position: this.manageScenarioWorkflowAddEditForm.controls['position'].value,
        organizationId: Number(this.cookieService.get('organizationId')),
        ispublic: this.isPublicValue,
      };
      this.saveManageScenarioWorkFlowEvent.emit(manageScenarioWorkFlowAddEditPayload);
      this.submitted = false;
    }
  }
}
